import React, { useContext, useState, createContext } from "react";

type DMMStateType = {
	isDMMPopupOpen: boolean;
	openDMMPopup: () => void;
	closeDMMPopup: () => void;
};

type ModalPopupStateType = DMMStateType;

const ModalPopup = createContext<ModalPopupStateType>({
	isDMMPopupOpen: true,
	openDMMPopup: () => {},
	closeDMMPopup: () => {},
});

export const useModalPopup = () => useContext(ModalPopup);

export const ModalPopupProvider = (props: {
	children: React.ReactNode;
}) => {
	const [isDMMPopupOpen, setIsDMMPopupOpen] = useState<boolean>(false);

	const dmmState: DMMStateType = {
		isDMMPopupOpen,
		openDMMPopup: () => setIsDMMPopupOpen(true),
		closeDMMPopup: () => setIsDMMPopupOpen(false),
	}

	return (
		<ModalPopup.Provider value={{
			...dmmState,
		}}>
			{props.children}
		</ModalPopup.Provider>
	);
};
